import React, { useEffect, useState } from "react";
import Header from "./Header";
import ButtonBar from "./ButtonBar";
import Footer from "./Footer";
import { useNavigate, useLocation } from "react-router-dom";
import './SignatureContainer.css';
import miraeLogo from '../Components/images/logo.svg';
import partnerLogo from '../Components/images/Partners-Logo.svg';
import backButton from '../Components/images/back_button.png';
import androidlogo from "../Components/images/google_play_logo.png"
import applelogo from "../Components/images/apple_logo.png"
import closelogo from "../Components/images/close_logo.svg"
import { language_selected } from "./language";

function SignatureContainer({ children, resetCanvas, signatureCanvasRef, base64Image, clearImage,language_text }) {
  const navigate = useNavigate();
  const location = useLocation();
 
  const navigateToCapture = () => {
    navigate("/");
  };

  const resetImage = () => {
    clearImage(); // Call the function to clear the image
    resetCanvas(); // Optionally reset the canvas as well
    hidePopupMessage(); // Hide the popup when the image is cleared
  };

  const hidePopupMessage = () => {
    const popup = document.getElementById("popupmessage");
    if (popup) {
      popup.style.display = "none"; // Hide the popup message
    }
  };

  // useEffect(() => {
  //   const deviceType = getDeviceType();
  //   sestDeviceType(deviceType)
  //   const u = new URLSearchParams(window.location.search).get("user_type");
  //   const p = new URLSearchParams(window.location.search).get("project_name");
  //   // const r = new URLSearchParams(window.location.search).get("request_id");
  //   setUserType(u || ""); // Set user_type from URL or default to "diy"  // "fresh" or "rejected" or "dormant"
  //   setProjectName(p || "diy"); // Set project_name from URL or default to "   // "diy"  or "partner"
  // }, [])

  // function getDeviceType() {
  //   const ua = navigator.userAgent || navigator.vendor || window.opera;
  //   if (/windows phone/i.test(ua)) {
  //     return "Windows Phone";
  //   }
  //   if (/android/i.test(ua)) {
  //     return "Android";
  //   }
  //   if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
  //     return "iOS";
  //   }
  //   if (/Win/i.test(ua)) {
  //     return "Windows";
  //   }
  //   if (/Mac/i.test(ua)) {
  //     return "Mac";
  //   }
  //   return "Other";
  // }

  return (
    <div>
      {/* <div className="logoMarginSet">
        <img src={logo} width="150" height="auto" />
      </div> */}

      {/* <div className="logoMarginSet">

        <div style={{ display: 'flex', alignItems: 'center', order: 1, width: '200px' }}>
          {
            projectName === "partner" ? <><img src={partnerLogo} width="200" height="auto" /></> : <><img src={miraeLogo} width="120" height="auto" /></>
          }
        </div>
        {
          userType === "fresh" ? <>
            {
              deviceType !== "Windows" &&
              <>
                {!isDismissed && (
                  <div className="banner-container" >
                    <div className="banner">
                      <span className="banner-text" onClick={onPlayStoreClick} >For better experience, download our app</span>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginLeft: '10px'
                      }}
                      >

                        {
                          deviceType === "Android" && <img
                            src={androidlogo}
                            width="30"
                            alt="Google Play"
                            className="app-icon"
                            onClick={onPlayStoreClick}
                          />
                        }
                        {
                          deviceType === "iOS" &&
                          <img
                            src={applelogo}
                            width="40"
                            alt="App Store"
                            className="app-icon"
                            onClick={onAppStoreClick}
                          />
                        }

                        <img
                          src={closelogo}
                          width="25"
                          alt="Close"
                          className="close-icon"
                          onClick={onCloseClick}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            }
          </> : <></>
        }

        <div style={{ width: '230px', order: 3 }}></div>
      </div> */}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="main-window-middle">
          <Header navigateToCapture={navigateToCapture} />
          <ButtonBar language_text={language_text} />

          {/* Conditionally render either the canvas or the uploaded base64 image */}
          {location.pathname !== "/Capture" && (
            <div className="hide-on-desktop drawSignBox"
              style={{
                textAlign: "center",
                position: "relative",
              }}
            >
             

              {base64Image ? (
                <img
                  src={base64Image}
                  id="image"
                  alt="Uploaded Signature"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <canvas
                  className="id hide-on-desktop"
                  ref={signatureCanvasRef}
                  id="signatureCanvas"
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                ></canvas>
              )}
            </div>
            
          )}
          {children}
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default SignatureContainer;
